import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import {GameRTPProfilePayload} from "../components/Utils/rtp-profiles";

export interface ConfigVersion {
    hall: number;
    id: number;
    version: number;
    created_on: string;
    auto_session_enabled: string;
    game_rtp_profiles?: GameRTPProfilePayload[];
}

export interface HallBaseConfig {
    id: number;
    name: string;
    tag: string;
    active: boolean;
    address_line_1: string;
    address_line_2: string;
    country: string;
    configs: ConfigVersion[];
    created_on: string;
}

export function configurationsList(
    state: { halls: HallBaseConfig[]; total: number } = { halls: [], total: 0 },
    action: Action
): { halls: HallBaseConfig[]; total: number } {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS:
            return {
                halls: action.payload.halls.results.map(hall => ({
                    ...hall,
                    configs: action.payload.configs.filter(
                        config => config.hall === hall.id
                    )
                })),

                total: action.payload.halls.count
            };
        default:
            return state;
    }
}

export function configurationsListLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST:
            return true;
        case ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS:
        case ConfigurationsActionTypes.GET_CONFIGURATIONS_LIST_FAIL:
            return false;
        default:
            return state;
    }
}
